// burger menu
import { bubble as Menu } from 'react-burger-menu';

// styling and images
import './style.css';


function Navbar() {
    return (
        <Menu>
            <a className='menu-item' href='/'>
                Home
            </a>
        </Menu>
    )
};

export default Navbar;